import HiringReports from './HiringReports.container';

export default HiringReports;
